import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { filterQuery } from '@culture/common-helpers/url';

import CustomSelect from 'components/filters/CustomSelect';
import SimpleSearch from 'components/filters/SimpleSearch';

import SortFilters from 'components/filters/SortFilters';

import ClearButton from 'components/filters/ClearButton';
import styles from './styles.module.scss';

const DesktopControls = ({
	defaultFiltersValues,
	filters,
	filtersValues,
	onFilterChange,
	onFilterReset,
	rubricPath,
	showSortFilter
}) => {
	const prepareDefaultValueFilters = _(filters).mapObject((val, key) => {
		if (
			(key === 'location' && val === 'russia') ||
			['sort', 'cleanCache'].includes(key)
		) {
			return null;
		}

		return val;
	});

	const showGlobalButtonClear =
		rubricPath !== 'traditions/foreign-heritage' &&
		!_(filterQuery(prepareDefaultValueFilters)).isEmpty();

	const locationAriaTitle =
		filtersValues?.currentLocale?.title || 'По всей России';

	const ethnicAriaTitle = filters?.ethnic
		? `: ${
				_(filtersValues?.ethnics).findWhere({ name: filters?.ethnic })?.title
		  }`
		: '';

	return (
		<div className={styles.DesktopControls}>
			<div className={styles.DesktopControls__Block}>
				{!_.isEmpty(filtersValues.locales) && (
					<CustomSelect
						controlTitleField="title"
						name="location"
						options={filtersValues.locales}
						onChange={onFilterChange}
						resetOption={{
							title: 'По всей России',
							sysName: defaultFiltersValues.location,
							titleGenitive: 'России'
						}}
						searchable
						selectedValue={filters.location}
						selectedOption={filtersValues?.currentLocale}
						valueField="sysName"
						ariaLabelButton={`Выбор местоположения объекта: ${locationAriaTitle}`}
					/>
				)}
				{rubricPath === 'traditions/culture-heritage' && (
					<CustomSelect
						apiParams={{
							url: 'ethnics',
							dataPath: 'items',
							debounce: 300,
							affectQueryParams: {
								_ids: !_.isEmpty(filtersValues?.ethnicsIds)
									? filtersValues?.ethnicsIds
									: null,
								sort: 'title',
								fields: ['title', 'name'].join(),
								status: 'published',
								withTotal: false
							},
							paginationType: 'pagination',
							withoutCache: true
						}}
						controlTitleField="title"
						name="ethnic"
						label="Этносы"
						options={filtersValues?.ethnics}
						onChange={onFilterChange}
						resetOption={{
							title: 'Все этносы',
							name: ''
						}}
						searchable
						selectedValue={filters?.ethnic}
						valueField="name"
						titleClassName={styles.title}
						ariaLabelButton={`Выбор этноса${ethnicAriaTitle}`}
					/>
				)}
				{showGlobalButtonClear && <ClearButton onClick={onFilterReset} />}
			</div>
			<div className={styles.DesktopControls__Block}>
				{!!showSortFilter && (
					<SortFilters
						onFilterChange={onFilterChange}
						currentSort={filters.sort}
					/>
				)}
				<SimpleSearch
					onEnter={onFilterChange}
					placeholder="Поиск по традициям"
					value={filters.query}
				/>
			</div>
		</div>
	);
};

DesktopControls.propTypes = {
	defaultFiltersValues: PropTypes.shape({
		location: PropTypes.string
	}),
	filters: PropTypes.shape({
		location: PropTypes.string,
		query: PropTypes.string,
		sort: PropTypes.string,
		ethnic: PropTypes.string
	}),
	filtersValues: PropTypes.shape({
		locales: PropTypes.array,
		currentLocale: PropTypes.shape({
			title: PropTypes.string,
			name: PropTypes.string
		}),
		ethnics: PropTypes.array,
		ethnicsIds: PropTypes.arrayOf(PropTypes.number)
	}),
	onFilterChange: PropTypes.func,
	onFilterReset: PropTypes.func,
	rubricPath: PropTypes.string,
	showSortFilter: PropTypes.bool
};

DesktopControls.defaultProps = {
	onFilterReset: _.noop,
	filters: {},
	filtersValues: {}
};

export default DesktopControls;
